var _excluded = ["src", "className", "onLoad", "imageRef", "includeWebP"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import Immutable from 'immutable';
import path from 'path';
import PropTypes from 'prop-types';
import mimeTypes from './data/ext-to-mime-types.json';
import './style.scss';
import { isValidImage, getImageExtension } from '../helpers';
var FALLBACK_MIME_TYPE = 'image/jpg';
var Picture = function Picture(_ref) {
  var src = _ref.src,
    className = _ref.className,
    _onLoad = _ref.onLoad,
    imageRef = _ref.imageRef,
    includeWebP = _ref.includeWebP,
    props = _objectWithoutProperties(_ref, _excluded);
  var width = props.width,
    height = props.height,
    alt = props.alt,
    title = props.title;
  var attrs = {
    className: className,
    typeof: 'foaf:Image',
    width: width,
    height: height,
    alt: alt,
    title: title
  };
  var getMimeType = function getMimeType(url) {
    var extension = getImageExtension(url);
    return mimeTypes[extension] ? mimeTypes[extension] : FALLBACK_MIME_TYPE;
  };
  if (Immutable.Iterable.isIterable(Immutable.fromJS(src))) {
    // Sources have to be defined in a descending order.
    // We sort them from best to worst quality.
    var sourcesAll = Immutable.fromJS(src).toOrderedMap().sortBy(function (url, breakpoint) {
      return parseInt(breakpoint);
    }).reverse();
    var sources = sourcesAll.map(function (url) {
      if (isValidImage(url)) {
        return url;
      }
    }).filter(function (image) {
      if (image !== false) {
        return image;
      }
      return null;
    });

    // Only render if all our image sources are valid
    var hasValidSources = sources.count() > 0;
    if (!hasValidSources) {
      return null;
    }
    var fallback = sources.valueSeq().first();
    var renderedSourcesWebP = [];
    if (includeWebP) {
      /* eslint-disable react/no-array-index-key */
      renderedSourcesWebP = sources.map(function (url, breakpoint) {
        var webpUrl = url.replace(/\.(png|gif|jp(e?)g)/ig, '.webp');
        return /*#__PURE__*/React.createElement("source", {
          key: breakpoint,
          srcSet: webpUrl,
          type: getMimeType(webpUrl),
          media: "screen and (min-width: ".concat(breakpoint, "px)")
        });
      }).valueSeq();
    }

    /* eslint-disable react/no-array-index-key */
    var renderedSources = sources.map(function (url, breakpoint) {
      return /*#__PURE__*/React.createElement("source", {
        key: breakpoint,
        srcSet: url,
        type: getMimeType(url),
        media: "screen and (min-width: ".concat(breakpoint, "px)")
      });
    }).valueSeq();
    return /*#__PURE__*/React.createElement("picture", {
      onLoad: function onLoad(e) {
        return _onLoad(e);
      }
    }, renderedSourcesWebP, renderedSources, /*#__PURE__*/React.createElement("img", _extends({}, attrs, {
      ref: imageRef,
      src: fallback
    })));
  }
  if (src && isValidImage(src)) {
    if (includeWebP) {
      var webpUrl = src.replace(/\.(png|gif|jp(e?)g)/, '.webp');
      return /*#__PURE__*/React.createElement("picture", {
        onLoad: function onLoad(e) {
          return _onLoad(e);
        }
      }, /*#__PURE__*/React.createElement("source", {
        srcSet: webpUrl,
        type: getMimeType(webpUrl)
      }), /*#__PURE__*/React.createElement("source", {
        srcSet: src,
        type: getMimeType(src)
      }), /*#__PURE__*/React.createElement("img", _extends({}, attrs, {
        ref: imageRef,
        src: src
      })));
    }
    return /*#__PURE__*/React.createElement("img", _extends({}, attrs, {
      onLoad: function onLoad(e) {
        return _onLoad(e);
      },
      ref: imageRef,
      src: src
    }));
  }
  return null;
};
Picture.propTypes = {
  onLoad: PropTypes.func,
  alt: PropTypes.string
};
Picture.defaultProps = {
  onLoad: function onLoad() {},
  alt: null
};
export default Picture;